import React from 'react';
import classNames from 'classnames/bind';
import { Tooltip } from '@fuxi/eevee-ui';
import { QuestionCircleOutlined } from '@ant-design/icons';

import styles from './index.module.less';

const cx = classNames.bind(styles);

export const LabelName: React.FC<{ name: string; info?: string; labelStyle?: React.CSSProperties }> = ({
  name,
  info,
  labelStyle,
}) => {
  return (
    <span className={cx('label-name')} style={labelStyle}>
      {name}
      {info && (
        <Tooltip placement="top" title={info}>
          <QuestionCircleOutlined className={cx('label-info-icon')} />
        </Tooltip>
      )}
    </span>
  );
};

export default LabelName;
